const DashboardOverviewStats = ({data}) => {
	return (
		<div className="dashboard-overview-stats">
			<div className="dashboard-overview-stat dashboard-overview-stat--lg">
				<h5 className="dashboard-overview-stat__title">Entries</h5>
				<span className="dashboard-overview-stat__count">{data?.total_entries}</span>
			</div>
			<div className="dashboard-overview-stat">
				<span className="dashboard-overview-stat__count">{data?.home_clubs}</span>
				<h5 className="dashboard-overview-stat__title">Home</h5>
			</div>
			<div className="dashboard-overview-stat">
				<span className="dashboard-overview-stat__count">{data?.oversea_clubs}</span>
				<h5 className="dashboard-overview-stat__title">Overseas</h5>
			</div>
			<div className="dashboard-overview-stat">
				<span className="dashboard-overview-stat__count">{data?.total_athletes}</span>
				<h5 className="dashboard-overview-stat__title">Athletes</h5>
			</div>
		</div>
	);
};

export default DashboardOverviewStats;
